import { render, staticRenderFns } from "./PositionExport.vue?vue&type=template&id=060ac12c"
import script from "./PositionExport.vue?vue&type=script&lang=js"
export * from "./PositionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports